export const CONFIG = {
  ENVIRONMENT:
    globalThis?.import_meta_env?.VUE_APP_ENVIRONMENT ||
    process.env.VUE_APP_ENVIRONMENT,
  VERSION:
    globalThis?.import_meta_env?.VUE_APP_VERSION || process.env.VUE_APP_VERSION,
  GIT_COMMIT:
    globalThis?.import_meta_env?.VUE_APP_GIT_COMMIT ||
    process.env.VUE_APP_GIT_COMMIT,
  GIT_BRANCH:
    globalThis?.import_meta_env?.VUE_APP_GIT_BRANCH ||
    process.env.VUE_APP_GIT_BRANCH,
  AUTH_URL:
    globalThis?.import_meta_env?.VUE_APP_AUTH_URL ||
    process.env.VUE_APP_AUTH_URL,
  PAY_FORM:
    globalThis?.import_meta_env?.VUE_APP_PAY_FORM ||
    process.env.VUE_APP_PAY_FORM,
  SUSPENDED_URL:
    globalThis?.import_meta_env?.VUE_APP_SUSPENDED_URL ||
    process.env.VUE_APP_SUSPENDED_URL,
  ALLOWED_COOKIE_DOMAIN:
    globalThis?.import_meta_env?.VUE_APP_ALLOWED_COOKIE_DOMAIN ||
    process.env.VUE_APP_ALLOWED_COOKIE_DOMAIN,
  SUCCESS_REDIRECT_DEFAULT:
    globalThis?.import_meta_env?.VUE_APP_SUCCESS_REDIRECT_DEFAULT ||
    process.env.VUE_APP_SUCCESS_REDIRECT_DEFAULT,
  LOGO_HREF:
    globalThis?.import_meta_env?.VUE_APP_LOGO_HREF ||
    process.env.VUE_APP_LOGO_HREF,
  API_URL:
    globalThis?.import_meta_env?.VUE_APP_API_URL || process.env.VUE_APP_API_URL,
  B2B_ENDPOINT_URL:
    globalThis?.import_meta_env?.VUE_APP_B2B_ENDPOINT_URL ||
    process.env.VUE_APP_B2B_ENDPOINT_URL,
  ENDPOINT_API_URL:
    globalThis?.import_meta_env?.VUE_APP_ENDPOINT_API_URL ||
    process.env.VUE_APP_ENDPOINT_API_URL,
  EMCD_API_URL:
    globalThis?.import_meta_env?.VUE_APP_EMCD_API_URL ||
    process.env.VUE_APP_EMCD_API_URL,
  RATES_API_URL:
    globalThis?.import_meta_env?.VUE_APP_RATES_API_URL ||
    process.env.VUE_APP_RATES_API_URL,
  AUTH_API_URL:
    globalThis?.import_meta_env?.VUE_APP_AUTH_API_URL ||
    process.env.VUE_APP_AUTH_API_URL,
  PAYER_API_URL:
    globalThis?.import_meta_env?.VUE_APP_PAYER_API_URL ||
    process.env.VUE_APP_PAYER_API_URL,
  POOL_API_URL:
    globalThis?.import_meta_env?.VUE_APP_POOL_API_URL ||
    process.env.VUE_APP_POOL_API_URL,
  COMMON_API_URL:
    globalThis?.import_meta_env?.VUE_APP_COMMON_API_URL ||
    process.env.VUE_APP_COMMON_API_URL,
  SENTRY_DSN:
    globalThis?.import_meta_env?.VUE_APP_SENTRY_DSN ||
    process.env.VUE_APP_SENTRY_DSN,
  SENTRY_DEBUG:
    globalThis?.import_meta_env?.VUE_APP_SENTRY_DEBUG ||
    process.env.VUE_APP_SENTRY_DEBUG,
  GTM_ID:
    globalThis?.import_meta_env?.VUE_APP_GTM_ID || process.env.VUE_APP_GTM_ID,
  INTERCOM_APP_ID:
    globalThis?.import_meta_env?.VUE_APP_INTERCOM_APP_ID ||
    process.env.VUE_APP_INTERCOM_APP_ID,
  SEGMENT_ID:
    globalThis?.import_meta_env?.VUE_APP_SEGMENT_ID ||
    process.env.VUE_APP_SEGMENT_ID,
  GROUP_IB_ID:
    globalThis?.import_meta_env?.VUE_APP_GROUP_IB_ID ||
    process.env.VUE_APP_GROUP_IB_ID,
  GOOGLE_OAUTH_CLIENT_ID:
    globalThis?.import_meta_env?.VUE_APP_GOOGLE_OAUTH_CLIENT_ID ||
    process.env.VUE_APP_GOOGLE_OAUTH_CLIENT_ID,
  TELEGRAM_BOT_ID:
    globalThis?.import_meta_env?.VUE_APP_TELEGRAM_BOT_ID ||
    process.env.VUE_APP_TELEGRAM_BOT_ID,
  TELEGRAM_BOT_NAME:
    globalThis?.import_meta_env?.VUE_APP_TELEGRAM_BOT_NAME ||
    process.env.VUE_APP_TELEGRAM_BOT_NAME,
  // * # FeatureToggleService
  UNLEASH_URL:
    globalThis?.import_meta_env?.VUE_APP_UNLEASH_URL ||
    process.env.VUE_APP_UNLEASH_URL,
  UNLEASH_CLIENT_KEY:
    globalThis?.import_meta_env?.VUE_APP_UNLEASH_CLIENT_KEY ||
    process.env.VUE_APP_UNLEASH_CLIENT_KEY,
  SEND_TO_EMAIL_SERVICE_URL:
    globalThis?.import_meta_env?.VUE_APP_SEND_TO_EMAIL_SERVICE_URL ||
    process.env.VUE_APP_SEND_TO_EMAIL_SERVICE_URL,
  EMCD_URL:
    globalThis?.import_meta_env?.VUE_APP_EMCD_URL ||
    process.env.VUE_APP_EMCD_URL,
  USE_MOCKS:
    globalThis?.import_meta_env?.VUE_APP_USE_MOCKS ||
    process.env.VUE_APP_USE_MOCKS,
  APP_URL: globalThis?.import_meta_env?.VUE_APP_URL || process.env.VUE_APP_URL,
  B2B_SWAP_APP_URL:
    globalThis?.import_meta_env?.VUE_APP_B2B_SWAP_APP_URL ||
    process.env.VUE_APP_B2B_SWAP_APP_URL,
}

export default CONFIG
